import { connect } from 'react-redux';
import { changeJourneyParam } from '@store/yourJourney';
import { DatePicker } from './DatePicker';

const mapDispatchToProps = (dispatch) => ({
  changeJourneyParam: (paramName, value) => dispatch(changeJourneyParam(paramName, value)),
});

export const DatePickerConnected = connect(null, mapDispatchToProps)(DatePicker);
